export const REGISTER_PAGE_NAMES = [
  'RegisterAssessment',
  'RegisterComplete',
  'RegisterConfirm',
  'RegisterCovidLanding',
  'RegisterFileUpload',
  'RegisterGateway',
  'RegisterGoodbye',
  'RegisterIntroduce',
  'RegisterInform',
  'RegisterInformAbc',
  'RegisterIntakeChoice',
  'RegisterLogout',
  'RegisterNewReturning',
  'RegisterNewReturningTwo',
  'RegisterNotFound',
  'RegisterPrescription',
  'RegisterSchedule',
  'RegisterSignUp',
  'RegisterSurvey',
  'RegisterThankyou',
  'RegisterVisit',
  'IneligiblePatient',
  'TruformeLanding',
  'TruformeNewReturning',
  'TruformePayInvoice',
  'TruformeCreateInvoice',
  'TruformeGeneratePrescription',
];

export const END = 'end';
export const REPEAT = 'repeat';
